import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'app',
  initialState: {
    error: null,
    bottomSheetOpen: false,
    bottomSheetOtherOpen: false,
    leftSheetOpen: true,
    rightSheetOpen: false,
    chatPanelWidth: 355,
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
    },
    setBottomSheetOpen: (state, action) => {
      state.bottomSheetOpen = action.payload;
    },
    setBottomOtherSheetOpen: (state, action) => {
      state.bottomSheetOtherOpen = action.payload;
    },
    setLeftSheetOpen: (state, action) => {
      state.leftSheetOpen = action.payload;
    },
    setRightSheetOpen: (state, action) => {
      state.rightSheetOpen = action.payload;
    },
    setChatPanelWidth: (state, action) => {
      state.chatPanelWidth = action.payload;
    },
  },
});

export default slice.reducer;

export const setError = (payload) => ({ type: 'app/setError', payload });
export const setBottomSheetOpen = (payload) => ({
  type: 'app/setBottomSheetOpen',
  payload,
});
export const setBottomOtherSheetOpen = (payload) => ({
  type: 'app/setBottomOtherSheetOpen',
  payload,
});
export const setLeftSheetOpen = (payload) => ({
  type: 'app/setLeftSheetOpen',
  payload,
});
export const setRightSheetOpen = (payload) => ({
  type: 'app/setRightSheetOpen',
  payload,
});
export const setChatPanelWidth = (payload) => ({
  type: 'app/setChatPanelWidth',
  payload,
});
